import React from 'react';
import PropTypes from 'prop-types';

import DialogTitle from 'ui/DialogTitle';

const title = {
  title: 'Edit Name/Title',
  description: 'Edit Bio/Description',
  custom_cta: 'Edit Call to Action',
  logo: 'Edit Profile Picture',
  cover_image: 'Edit Header Image',
  social_links: 'Edit Social Links',
  publish: 'Publish your Club',
};

const Title = ({ name, onCancel }) => {

  return (
    <DialogTitle title={title[name]} onClose={onCancel} />
  );
}

Title.propTypes = {
  name: PropTypes.string,
  onCancel: PropTypes.func,
}; 

export default Title;